import React from 'react';
import { Modal } from 'react-bootstrap';
import ChartBars from '../../charts/bars';

const MapModal = React.createClass({
  getInitialState() {
    return { showModal: false };
  },

  componentWillReceiveProps(nextProps) {
    const { showModal } = nextProps;
    this.setState({ showModal });
  },

  _renderBarData() {
    return (
      <ChartBars data={this.props.stateData} />
    );
  },

  render() {

    return (
      <div>
        <Modal show={this.state.showModal} {...this.props}>
          <Modal.Header closeButton>
            <Modal.Title>{this.props.stateData.stateName}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {this._renderBarData()}
          </Modal.Body>
        </Modal>
      </div>
    );
  }
});

export default MapModal;



/** WEBPACK FOOTER **
 ** ./src/components/charts/map/map_modal.js
 **/